import React, { Component } from "react";
import { render } from "react-dom";
class Get extends Component {
  constructor() {
    super();
  }
  componentWillMount() {
    this.getData();
  }
  getData() {
    // create a new XMLHttpRequest
    var xhr = new XMLHttpRequest();

    // get a callback when the server responds
    xhr.addEventListener("load", () => {
      // update the state of the component with the result here
      console.log(xhr.responseText);
    });
    // open the request with the verb and the url
    xhr.open("GET", "https://fillyourbasket.herokuapp.com/");
    // send the request
    xhr.send();
  }

  render() {
    return (
      <div>
        <a href="https://fillyourbasket.herokuapp.com/"> click here </a>
        <p> </p>
      </div>
    );
  }
}
export default Get;
